// const { Core, Events } = Global;

// customElements.define('main-nav-mobile', class extends Core {
//     elements = {
//         $: [['level'], 'toolbar']
//     }

//     render() {
//         this.sub(Events.HEADER_UPDATE, this._handleHeaderUpdate, { global: true, once: true });
//         this.sub(Events.HEADER_TOOLBAR_UPDATE, this._handleToolbarUpdate, { global: true, once: true });
//         this.$({
//             change: this._handleChange
//         })
//     }
    
//     _handleChange(e) {
//         this.style.setProperty(
//             `--${this.tagName.toLowerCase()}-level`,
//             e.target.value
//         );
//     }

//     _handleHeaderUpdate(items) {
//         this.$('level').map(level => {
//             const match = items.find(item => +level.dataset.level === item.level);
//             if(match) {
//                 level.append(...match.children);
//             }
//         })
//     }

//     _handleToolbarUpdate(items) {
//         this.$('toolbar').append(...items);
//     }
// });

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.main-nav-mobile-accordion-trigger');
  if (!trigger) return;

  const item = trigger.closest('.main-nav-mobile-item');
  if (!item) return;

  const submenu = item.querySelector('.main-nav-mobile-submenu');
  if (!submenu) return;

  const isOpen = trigger.getAttribute('aria-expanded') === 'true';

  // Close sibling submenus at the same level
  const siblings = item.parentElement.querySelectorAll('.main-nav-mobile-item.is-open');
  siblings.forEach(sib => {
    if (sib !== item) {
      const sibTrigger = sib.querySelector('.main-nav-mobile-accordion-trigger');
      const sibSubmenu = sib.querySelector('.main-nav-mobile-submenu');
      if (sibTrigger && sibSubmenu) {
        sibTrigger.setAttribute('aria-expanded', 'false');
        sibSubmenu.hidden = true;
        sib.classList.remove('is-open');
      }
    }
  });

  trigger.setAttribute('aria-expanded', String(!isOpen));
  submenu.hidden = isOpen;
  item.classList.toggle('is-open', !isOpen);
});

